export const RESTRICTIONS = 'Можно установить двери-купе к натяжному потолку?';
export const DELIVERY = 'Как далеко доставляете от Москвы и Санкт-Петербурга?';
export const DEADLINE = 'Доставка и сборка происходят в один день?';
export const PROPERTIES = 'Какая толщина у ЛДСП-панелей?';
export const SELF_INSTALATION = 'Можно ли установить гардеробную самостоятельно?';
